import React from "react";
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Clients from "./pages/clients";
import Login from "./pages/login";
import Users from "./pages/users";
import Home from "./pages/home";
import "bootstrap/dist/css/bootstrap.min.css";
import Uvr from "./pages/uvr"; 
import Documents from "./pages/documents";
import Search from "./pages/search";
import Credits from "./pages/credits";
import ClosedPeriods from "./pages/closedPeriods";
import Logs from "./pages/logs";
import Debug from "./pages/debug";
import AccessDenied from "./pages/accessDenied";

import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Version from "./components/version";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      roleId: "",
    };
  }

  componentDidMount = () => {
    let loggedIn = window.sessionStorage.getItem("loggedIn");
    if (loggedIn === "true") {
      this.setState({
        roleId: JSON.parse(
          atob(window.sessionStorage.getItem("localToken").split(".")[1])
        ).roleId,
      });
      // Scroll listener para el content-area
      const contentDiv = document.getElementById("content-scrollbar");
      if (contentDiv) {
        contentDiv.addEventListener("scroll", () => {
          if (contentDiv.scrollTop > 0) {
            const navBar = document.getElementById("nav-bar");
            if (navBar) navBar.classList.add("scrolled");
          } else {
            const navBar = document.getElementById("nav-bar");
            if (navBar) navBar.classList.remove("scrolled");
          }
        });
      }
    }
  };

  logOut = () => {
      sessionStorage.clear();
      sessionStorage.setItem("loggedIn", false);
      window.location.href = '/login';
  }

  render = () => {
    const isLoggedIn = !!window.sessionStorage.getItem("localToken");

    return (
      <BrowserRouter>
        {isLoggedIn ? (
          /* ─── Logged-in Layout: Nuevo shell con Navbar + Sidebar + Content ─── */
          <div className="app-container">
            <Navbar />
            <div className="app-main">
              <Sidebar />
              <main className="content-area" id="content-scrollbar">
                <Routes>
                  <Route path="/home" element={<Home />} />
                  <Route path="/" element={<Navigate to="/home" replace />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/clients/*" element={<Clients />} />
                  <Route path="/credits/*" element={<Credits />} />
                  <Route path="/users" element={<Users />} />
                  <Route path="/search/*" element={<Search />} />
                  <Route path="/uvr" element={<Uvr />} />
                  <Route path="/documents" element={<Documents />} />
                  <Route path="/closedPeriods" element={<ClosedPeriods />} />
                  <Route path="/logs" element={<Logs />} />
                  <Route path="/debug" element={<Debug />} />
                  <Route path="/access-denied" element={<AccessDenied />} />
                  <Route path="*" element={<Navigate to="/home" replace />} />
                </Routes>
              </main>
            </div>
            <Version />
          </div>
        ) : (
          /* ─── Not logged in: solo Login, sin chrome ─── */
          <div className="app-container">
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
          </div>
        )}
      </BrowserRouter>
    );
  };
}

export default App;
